import { TeamCompetitionExemptionReason } from "../types/team_competitions.types";
import { ResponseData } from "./types";
import { httpClient } from "./common";
import { withApiErrorHandling } from "./withApiErrorHandling";

export class TeamCompetitionsAPI {
  private static readonly API_URL = "/team_competitions";

  static async registerTeamToCompetition(id: number): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.post(`${TeamCompetitionsAPI.API_URL}/${id}`, undefined, true),
      "Error al registrar el equipo en la competencia"
    );
  }

  static async leaveTeamFromCompetition(id: number): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.delete(`${TeamCompetitionsAPI.API_URL}/${id}`, true),
      "Error al abandonar la competencia"
    );
  }

  static async exemptTeamCompetition(
    tcId: number,
    exemptionData: {
      exemption_reason: TeamCompetitionExemptionReason;
      exemption_notes: string | null;
    }
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.patch(`${TeamCompetitionsAPI.API_URL}/${tcId}/exemption`, exemptionData, true),
      "Error al eximir de pago al equipo"
    );
  }

  static async removeExemption(tcId: number): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.delete(`${TeamCompetitionsAPI.API_URL}/${tcId}/exemption`, true),
      "Error al remover la exención de pago al equipo"
    );
  }
}
